//empty for future user actions
import * as actionTypes from "../types";
import * as firebase from "../../utils/firebase";
import { onSnapshot } from "firebase/firestore";


export const getEbooks = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getEbooks(), book => {
            var books = [];
            book.forEach((doc) => {
                books.push({ ...doc.data(), id: doc.id })
            });
            if (books.length > 0) {
                dispatch({
                    type: actionTypes.GET_EBOOK,
                    payload: {
                        ebooks: books,
                        ebookEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_EBOOK,
                    payload: {
                        ebooks: books,
                        ebookEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}

export const resetEbooks = () => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_EBOOK,
            payload: {
                ebooks: [],
                ebookEmpty: false
            }
        });
    } catch (err) {
        console.error(err);
    }
}

